import React, { useEffect, useState } from 'react'
import Gauge from './Tuner/Gauge'
import Note from './Tuner/Note'
import { PitchDetector } from "pitchy";
import tunerLib from '../../util/tuner';
import { useMedia } from '../MediaStreamContext'

export default () => {
    const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
    const detector = PitchDetector.forFloat32Array(4096);

    const [source, setSource] = useState(null)
    const [processor, setProcessor] = useState(null)
    const [started, setStarted] = useState(null)
    const [note, setNote] = useState(null)
    const [octave, setOctave] = useState(null)
    const [cents, setCents] = useState(null)
    const [concertPitch, setConcertPitch] = useState(440)
    const [accidental, setAccidental] = useState('x')
    let oorCounter = 0
    const pitches = []
    const [state, actions] = useMedia()

    const analyzePitchArray = (pitches) => pitches.reduce((acc, curr) => (acc + curr.pitch), 0) / pitches.length

    const updatePitch = data => {
        const buffer = data.inputBuffer.getChannelData(0).map(O => O * 50)
        const [_pitch, _clarity] = detector.findPitch(buffer, audioContext.sampleRate);
        if (_clarity >= 0.965) {
            oorCounter = 0;

            pitches.push({pitch: _pitch, time: + new Date()})

            if(pitches.length > 5){
                pitches.splice(0,1);
            }

            const half_steps = tunerLib.DetermineHalfSteps(analyzePitchArray(pitches), concertPitch);
            const note_idx = tunerLib.DetermineNoteIndex({ half_steps });
            if (!isNaN(note_idx)) {
                //If there is a second character in the note name
                if (tunerLib.Notes[note_idx].split("").length === 2) {
                    const split = tunerLib.Notes[note_idx].split("");
                    setNote(split[0]);

                    switch (split[1]) {
                        case "#":
                            setAccidental("#");
                            break;
                        case "b":
                            setAccidental("b");
                            break;
                        default:
                            setAccidental("x");
                    }
                } else {
                    setAccidental("x");
                    setNote(tunerLib.Notes[note_idx]);
                }
                setOctave(tunerLib.DetermineOctave({ note_idx, half_steps }));
                setCents(tunerLib.DetermineDiff({ half_steps }) * 100);
            }
        } else {
            if(oorCounter === 5) {
                setAccidental("x");
                setNote(null);
                setOctave(null);
                setCents(null);
                pitches.splice(0, pitches.length);
                oorCounter = 0;
            }else{
                oorCounter++;
            }
        }
    }

    useEffect(() => {
        actions.init({audioOnly: true})

        return () => {
            if(processor){
                processor.removeEventListener('audioprocess', updatePitch, true)
                processor.disconnect()
                setProcessor(null)
            }
            if(source){
                source.disconnect()
                setSource(null)
            }

            audioContext.close()
            actions.close()
        }
    }, [])

    useEffect(() => {
        if(state.stream) {
            const sourceNode = audioContext.createMediaStreamSource(state.stream)
            const processorNode = audioContext.createScriptProcessor(4096, 2, 2)
            processorNode.addEventListener('audioprocess', updatePitch, true)
            sourceNode.connect(processorNode)
            processorNode.connect(audioContext.destination)
            setSource(sourceNode)
            setProcessor(processorNode)
        }
    }, [state.stream])

    return (
        <Gauge min={-50} max={50} value={cents}>
            <Note direction={accidental} octave={octave} cents={cents}>
                {note}
            </Note>
        </Gauge>
    )
};
